import { render, staticRenderFns } from "./update-user.vue?vue&type=template&id=24e058a2"
import script from "./update-user.vue?vue&type=script&lang=js"
export * from "./update-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports